export type RatePresetLike = {
  client_id: string | null;
  effective_from: string;
  hourly_rate_cents: number;
  project_id: string | null;
};

export function resolveRatePresetCents(
  rates: RatePresetLike[],
  context: {
    clientId?: string | null;
    date?: string;
    projectId?: string | null;
  },
) {
  const effectiveDate = context.date ?? new Date().toISOString().slice(0, 10);
  const matches = rates
    .filter((rate) => {
      if (rate.effective_from > effectiveDate) return false;
      if (rate.project_id && rate.project_id !== context.projectId)
        return false;
      if (rate.client_id && rate.client_id !== context.clientId) return false;
      return true;
    })
    .sort((left, right) => {
      const leftSpecificity = left.project_id ? 2 : left.client_id ? 1 : 0;
      const rightSpecificity = right.project_id ? 2 : right.client_id ? 1 : 0;
      return (
        rightSpecificity - leftSpecificity ||
        right.effective_from.localeCompare(left.effective_from)
      );
    });

  return matches[0]?.hourly_rate_cents ?? null;
}
